function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "primary/eye",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M14,0 C7.63636364,0 2.20181818,3.95818182 0,9.54545455 C2.20181818,15.1327273 7.63636364,19.0909091 14,19.0909091 C20.3636364,19.0909091 25.7981818,15.1327273 28,9.54545455 C25.7981818,3.95818182 20.37,0 14,0 Z M14,15.9090909 C10.4872727,15.9090909 7.63636364,13.0581818 7.63636364,9.54545455 C7.63636364,6.03272727 10.4872727,3.18181818 14,3.18181818 C17.5127273,3.18181818 20.3636364,6.03272727 20.3636364,9.54545455 C20.3636364,13.0581818 17.5127273,15.9090909 14,15.9090909 Z M14,5.72727273 C11.8936364,5.72727273 10.1818182,7.43909091 10.1818182,9.54545455 C10.1818182,11.6518182 11.8936364,13.3636364 14,13.3636364 C16.1063636,13.3636364 17.8181818,11.6518182 17.8181818,9.54545455 C17.8181818,7.43909091 16.1063636,5.72727273 14,5.72727273 Z",
  id: "eye-icon"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    version: 1.1
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/eye-icon.510263fc.svg";
export { SvgComponent as ReactComponent };